import React from 'react'
import styles from './styles.module.scss'

export type NumberBlockProps = {
    number: string | number
    text: string
    tooltip?: string
}

export const NumberBlock = ({ number, text, tooltip }: NumberBlockProps) => (
    <div className={styles.wrapper} title={tooltip}>
        <div className={styles.number}>{number}</div>
        <div className={styles.text}>{text}</div>
    </div>
)
